// src/config.js
export const BACKEND_URL = "https://quran2-975745335288.us-west1.run.app";